import {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {isNil, equals} from 'ramda'

import {
  getMessageSentHistory,
  persistMessageSentHistory
} from '@daedalus/core/src/utils/persistence'

import {
  getChannelsAttempts,
  getChannelProp
} from '@daedalus/core/src/auth/modules/selectors'
import {
  setMessageAttemptsHistory,
  initialChannelsState
} from '@daedalus/core/src/auth/modules/slice'

const SyncMessagesHistoryWithBrowserStorage = () => {
  const dispatch = useDispatch()
  const browserStorage = getMessageSentHistory()
  const attemptsHistory = useSelector(getChannelsAttempts)

  // Sync browser storage with redux state
  useEffect(() => {
    // Initialize attempts history
    if (isNil(browserStorage)) {
      return persistMessageSentHistory(attemptsHistory)
    }

    dispatch(setMessageAttemptsHistory(browserStorage))
  }, [])

  // Sync browser storage with redux state
  useEffect(() => {
    // Initialize attempts history
    if (
      !equals(attemptsHistory, getChannelProp('attempts', initialChannelsState))
    ) {
      return persistMessageSentHistory(attemptsHistory)
    }
  }, [attemptsHistory])

  return null
}

export default SyncMessagesHistoryWithBrowserStorage
